import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface Props {
  description: string;
  onDescriptionChange: (value: string) => void;
  overheadInput: string;
  onOverheadChange: (value: string) => void;
  discountPctInput: string;
  onDiscountPctChange: (value: string) => void;
  discountAmountInput: string;
  onDiscountAmountChange: (value: string) => void;
  defaultOverheadPct: number;
  readOnly: boolean;
  /** VIB-994: T&M-mersalg fakturers på medgått tid + materiell, ikke en fast
   *  linjesum — overhead/rabatt-kortet er meningsløst og skjules. */
  billingMode?: "fixed" | "tm";
}

export function UpsellAmountFields({
  description,
  onDescriptionChange,
  overheadInput,
  onOverheadChange,
  discountPctInput,
  onDiscountPctChange,
  discountAmountInput,
  onDiscountAmountChange,
  defaultOverheadPct,
  readOnly,
  billingMode = "fixed",
}: Props) {
  return (
    <>
      <div>
        <Label htmlFor="upsell-description">Tittel (vises på faktura)</Label>
        <Input
          id="upsell-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="F.eks. Ekstra klippedag oktober"
          disabled={readOnly}
        />
      </div>

      {/* VIB-665: Overhead + rabatt per mersalg. Default-overhead vises som hint.
          VIB-994: skjules for T&M — faktureres på medgått tid, ikke en fastsum. */}
      {billingMode !== "tm" && (
      <Card>
        <CardContent className="p-4 space-y-3">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-display text-base">Påslag og rabatt</h3>
            <span className="text-xs text-muted-foreground">
              Default fra prosjekt: {defaultOverheadPct}%
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div>
              <Label htmlFor="upsell-overhead" className="text-xs">
                Overhead (%)
              </Label>
              <Input
                id="upsell-overhead"
                type="number"
                min={0}
                step="0.5"
                value={overheadInput}
                onChange={(e) => onOverheadChange(e.target.value)}
                disabled={readOnly}
                placeholder={`${defaultOverheadPct} (default)`}
              />
            </div>
            <div>
              <Label htmlFor="upsell-discount-pct" className="text-xs">
                Rabatt (%)
              </Label>
              <Input
                id="upsell-discount-pct"
                type="number"
                min={0}
                step="0.5"
                value={discountPctInput}
                onChange={(e) => onDiscountPctChange(e.target.value)}
                disabled={readOnly}
                placeholder="0"
              />
            </div>
            <div>
              <Label htmlFor="upsell-discount-amount" className="text-xs">
                Rabatt (kr)
              </Label>
              <Input
                id="upsell-discount-amount"
                type="number"
                min={0}
                step="100"
                value={discountAmountInput}
                onChange={(e) => onDiscountAmountChange(e.target.value)}
                disabled={readOnly}
                placeholder="0"
              />
            </div>
          </div>
          <p className="text-[11px] text-muted-foreground">
            Fast rabatt-beløp overstyrer prosent hvis begge er satt. Tomt overhead-felt = bruk prosjektets default.
            Endringer lagres med «Lagre».
          </p>
        </CardContent>
      </Card>
      )}
    </>
  );
}
